function defaultState() {
  return {
    activeContextMenu: ""
  };
}

export default {
  namespaced: true,
  state: {
    ...defaultState()
  },
  mutations: {
    "set-active-contextmenu": function (state, args) {
      state.activeContextMenu = args;
    },
    "clear-active-contextMenu": function (state) {
      state.activeContextMenu = "";
    }
  },
  actions: {
    openContextMenu: async function ({ commit }, args) {
      commit("set-active-contextmenu", args);
    },
    closeContextMenu: async function ({ commit }) {
      commit("clear-active-contextMenu");
    }
  },
  getters: {
    isActiveContextMenu: (state) => (widgetId) => {
      return state.activeContextMenu === widgetId;
    }
  },
  modules: {}
};
